module.exports = "./img/fda39c2d3cdc74331c2d961f0f8a4947.jpg";